import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { mixpanel, constants, links } from 'common/helpers'

import HeaderBanner from 'components/ui/banners/HeaderBanner/HeaderBanner'

import messages from './messages'


class ShippedBanner extends PureComponent {

  static propTypes = {
    onClose: PropTypes.func.isRequired,
    shippedItem: PropTypes.object.isRequired,
  }

  onTrackingNumberClick = () => {
    mixpanel.track(constants.analyticsEvents.trackingNumberClick, {
      placement: 'banner',
    })
  }

  render() {
    const { onClose, shippedItem: { month, tracking } } = this.props
    const { trackingUrl } = tracking || {}

    const shippedMonth = moment.months()[month - 1]
    let bannerLinkProps = {}

    if (trackingUrl) {
      bannerLinkProps = {
        link: links.tracking,
      }
    }

    return (
      <HeaderBanner
        onClose={onClose}
        textMessage={messages.text}
        valuesMessage={{ shippedMonth }}
        btnMessage={messages.button}
        onClick={this.onTrackingNumberClick}
        {...bannerLinkProps}
      />
    )
  }
}


export default ShippedBanner
